import { OnRecordCallback } from './types';

interface IShared {
    onReport: OnRecordCallback | null;
    prevEvent: Event | null;
}

const shared: IShared = {
    onReport: null,
    prevEvent: null,
};

export default shared;
